import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { EntryContainer } from '../entry/containers/entry-container';
import { publicRoutePaths } from './models/path-model';

const AuthorizationSignaturePage = React.lazy(
  () => import('./pages/authorization-signature-page'),
);
const AuthorizationSignatureValidationPage = React.lazy(
  () => import('./pages/authorization-signature-validation-page'),
);

export const publicRoutes: Sebrae.RoutesConfig = [
  {
    routePath: publicRoutePaths.storyAuthorizationSignature,
    pageToRender: (
      <EntryContainer>
        <AuthorizationSignaturePage />
      </EntryContainer>
    ),
    ifIsAuthenticated: false,
  },
  {
    routePath: publicRoutePaths.storyAuthorizationValidation,
    pageToRender: (
      <EntryContainer>
        <AuthorizationSignatureValidationPage />
      </EntryContainer>
    ),
    ifIsAuthenticated: false,
  },
];
